import { Box, MenuItem, TextField, Typography } from "@material-ui/core"
import BoardDetailsCheckboxes from "components/Clerk/Boards/BoardDetailsCheckboxes"
import { useFormikContext } from "formik"
import PropTypes from "prop-types"

import useStyles from "./styles"

const Step2 = ({
  areasOfInterest,
  setAreasOfInterest,
  areasOfExpertise,
  setAreasOfExpertise,
  areasOfExperience,
  setAreasOfExperience,
}) => {
  const classes = useStyles()

  const { values, handleChange, touched, errors } = useFormikContext()

  return (
    <Box>
      <Box display="flex" alignItems="flex-end">
        <Box width="30%" className={classes.input}>
          <Typography className={classes.label}>Minimum Degree</Typography>
          <TextField
            select
            name="minimum_degree"
            value={values.minimum_degree}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            helperText={touched.minimum_degree && errors.minimum_degree}
            error={touched.minimum_degree && errors.minimum_degree}
            style={{ backgroundColor: "#F8F8F8", marginBottom: "25px" }}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"high school or equivalent"}>
              High School or Equivalent
            </MenuItem>
            <MenuItem value={"professional certificate"}>
              Professional Certificate
            </MenuItem>
            <MenuItem value={"associates"}>Associates</MenuItem>
            <MenuItem value={"bachelor's"}>{"Bachelor’s"}</MenuItem>
            <MenuItem value={"master's"}>{"Master's"}</MenuItem>
            <MenuItem value={"ph.d"}>Ph.D </MenuItem>
            <MenuItem value={"md"}>MD</MenuItem>
            <MenuItem value={"jd"}>JD</MenuItem>
          </TextField>
        </Box>
        <Box width="30%" className={classes.input}>
          <Typography className={classes.label}>Occupation Required</Typography>
          <TextField
            select
            name="occupation_required"
            value={values.occupation_required}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            helperText={
              touched.occupation_required && errors.occupation_required
            }
            error={touched.occupation_required && errors.occupation_required}
            style={{ backgroundColor: "#F8F8F8", marginBottom: "25px" }}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"true"}>True </MenuItem>
            <MenuItem value={"false"}>False </MenuItem>
            <MenuItem value={"n/a"}>N/A </MenuItem>
          </TextField>
        </Box>
      </Box>
      <BoardDetailsCheckboxes
        type="Interest"
        areasArray={areasOfInterest}
        setAreasArray={setAreasOfInterest}
        errors={errors}
      />
      <BoardDetailsCheckboxes
        type="Expertise"
        areasArray={areasOfExpertise}
        setAreasArray={setAreasOfExpertise}
        errors={errors}
      />

      <BoardDetailsCheckboxes
        type="Experience"
        areasArray={areasOfExperience}
        setAreasArray={setAreasOfExperience}
        errors={errors}
      />
    </Box>
  )
}
Step2.propTypes = {
  areasOfInterest: PropTypes.array,
  setAreasOfInterest: PropTypes.func,
  areasOfExpertise: PropTypes.array,
  setAreasOfExpertise: PropTypes.func,
  areasOfExperience: PropTypes.array,
  setAreasOfExperience: PropTypes.func,
}

export default Step2
